function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M22.487 36.892h-7.244V21.041h-3.962v-6.253h3.962v-4.304a6.601 6.601 0 016.594-6.594h4.613v6.253h-2.632c-.734 0-1.331.597-1.331 1.332v3.313h6.254l-2.501 6.253h-3.753v15.851zm-5.944-1.301h4.644v-15.85h4.173l1.462-3.653h-5.635v-4.613a2.634 2.634 0 012.632-2.631h1.331V5.19h-3.313a5.3 5.3 0 00-5.294 5.294v5.604h-3.962v3.653h3.962v15.85z"
})));

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/facebook.d8a07e56.svg";
export { SvgFacebook as ReactComponent };